import React, { useEffect, useState } from "react";
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import api from "@/lib/api";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { StudentPickerMulti } from "@/components/StudentPicker";

export function CashiersDialog({ open, onOpenChange }) {
  const qc = useQueryClient();
  const [ids, setIds] = useState([]);
  const { data: cashiers } = useQuery({ queryKey: ["bar-cashiers"], queryFn: async () => (await api.get("/bar/cashiers")).data, enabled: open });
  const { data: students = [] } = useQuery({ queryKey: ["students-active-min"], queryFn: async () => (await api.get("/students", { params: { status: "attivo" } })).data, enabled: open });
  useEffect(() => { if (cashiers) setIds(cashiers.map((c) => c.id)); }, [cashiers]);
  const save = useMutation({
    mutationFn: async () => (await api.put("/bar/cashiers", { student_ids: ids })).data,
    onSuccess: (d) => { qc.setQueryData(["bar-cashiers"], d); toast.success(`${d.length} cassieri abilitati`); onOpenChange(false); },
    onError: (e) => toast.error(e.response?.data?.detail || "Errore"),
  });
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-lg max-h-[90vh] overflow-y-auto overflow-x-hidden grid-cols-1 [&>*]:min-w-0" data-testid="cashiers-dialog">
        <DialogHeader><DialogTitle>Cassieri del bar</DialogTitle></DialogHeader>
        <p className="text-sm text-stone-600">Gli studenti scelti vedono nel loro portale solo la <b>Cassa bar</b>: possono addebitare voci del listino agli altri studenti e incassare in contanti da docenti e clienti. Non vedono saldi, statistiche o altri dati e non possono modificare o annullare movimenti.</p>
        <Button onClick={() => save.mutate()} disabled={save.isPending} className="bg-[#1C352D] hover:bg-[#264A3E] self-start" data-testid="cashiers-save">Salva cassieri ({ids.length})</Button>
        <StudentPickerMulti students={students} values={ids} onChange={setIds} testId="cashiers-picker"/>
        <p className="text-xs text-stone-500">Incassi del giorno, riepilogo per prodotto e cassa di versamento: <b>Wallet → Incassi bar</b>.</p>
      </DialogContent>
    </Dialog>
  );
}
